import { LOADING_DIV_ID } from "./SwipeOverlay";

const MINIMUM_SWIPE_PX = 50;

const safeRequestIdleCallback = (
  cb: () => void,
  options?: IdleRequestOptions,
) => {
  if ("requestIdleCallback" in window) {
    (window as any).requestIdleCallback(cb, options);
  } else {
    setTimeout(cb, options?.timeout || 100);
  }
};

const initSwipeNavigation = (nextArticlePath: string | null) => {
  let touchStartX = 0;
  let touchStartY = 0;
  let currentX = 0;
  let isSwipingHorizontally = false;
  const loadingDiv = document.getElementById(LOADING_DIV_ID);

  if (!loadingDiv) return;

  const handleTouchStart = (e: TouchEvent) => {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
    isSwipingHorizontally = false;
  };

  const handleTouchMove = (e: TouchEvent) => {
    currentX = e.changedTouches[0].screenX;
    const deltaX = touchStartX - currentX;
    const deltaY = Math.abs(touchStartY - e.changedTouches[0].screenY);

    if (Math.abs(deltaX) > deltaY) {
      isSwipingHorizontally = true;
      e.preventDefault();

      if (loadingDiv) {
        loadingDiv.style.transform = `translateX(${Math.max(
          100 - (deltaX / (window.innerWidth * 0.5)) * 100,
          0,
        )}%)`;
      }
    }
  };

  const handleTouchEnd = () => {
    const deltaX = touchStartX - currentX;
    if (!loadingDiv) return;

    if (isSwipingHorizontally) {
      if (deltaX > MINIMUM_SWIPE_PX) {
        loadingDiv.style.transform = "translateX(0)";
        safeRequestIdleCallback(
          () => {
            if (nextArticlePath) {
              if (document.startViewTransition) {
                document.startViewTransition(() => {
                  window.location.href = nextArticlePath;
                });
              } else {
                window.location.href = nextArticlePath;
              }
            }
          },
          { timeout: 200 },
        );
      } else {
        loadingDiv.style.transform = "translateX(100%)";
      }
    }
  };

  document.addEventListener("touchstart", handleTouchStart, { passive: true });
  document.addEventListener("touchmove", handleTouchMove, { passive: false });
  document.addEventListener("touchend", handleTouchEnd);

  return () => {
    document.removeEventListener("touchstart", handleTouchStart);
    document.removeEventListener("touchmove", handleTouchMove);
    document.removeEventListener("touchend", handleTouchEnd);
  };
};

export default initSwipeNavigation;
